import React from "react"
import { Card, Modal, Button } from "react-bootstrap"
import { FaDownload, FaEye, FaTrash } from "react-icons/fa"
import { reactLocalStorage } from "reactjs-localstorage";

import DocumentAPI from "../../../api/DocumentAPI";
import Util from "../../../util/Util";
import Const from "../../../util/Constants";

class DocumentTab extends React.Component {
  constructor(props) {
    super(props);

    this.models = reactLocalStorage.getObject(Const.Model);
    this.model = this.models.document;

    this.perm = {
      view: Util.isAllow(this.model.permission, Const.PermView),
      delete: Util.isAllow(this.model.permission, Const.PermDelete),
    };

    this.state = {
      inApiCall: false,
      documents: [],
      previewImage: null,
    };
  }

  componentDidMount() {
    if (this.perm.view) {
      this.loadDocuments(this.props.id);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.id !== this.props.id && this.perm.view) {
      this.loadDocuments(nextProps.id);
    }
  }

  loadDocuments = (id) => {
    this.setState({ inApiCall: true });

    DocumentAPI.getInnerList(
      this.props.type,
      id,
      this.onReceived,
      this.onFail
    );
  };

  onReceived = (res) => {
    this.props.onCount?.("document", res.count);
    this.setState({ inApiCall: false, documents: res.data });
  };

  onFail = (res) => {
    Util.showError(res?.message || "Failed to load documents");
    this.setState({ inApiCall: false });
  };

  onDelete = (docId) =>
    Util.confirmAlert(
      "Delete",
      "Are you sure you want to delete this document?",
      "Delete",
      "No",
      () => {
        this.setState({ inApiCall: true });
        DocumentAPI.delete(docId, this.onDeleteSuccess, this.onFail);
      }
    );

  onDeleteSuccess = () => {
    Util.showNotification(
      "Successful",
      "Document deleted successfully",
      "success"
    );
    this.loadDocuments(this.props.id);
    this.props.reload?.();
  };

  render() {
    if (!this.perm.view) return null;

    return (
      <DocumentGrid
        documents={this.state.documents}
        canDelete={this.perm.delete}
        onDelete={this.onDelete}
      />
    );
  }
}

const DocumentGrid = ({ documents = [], canDelete, onDelete }) => {
  const [previewImage, setPreviewImage] = React.useState(null);

  const isImage = (type) => type?.startsWith("image");
  const isPdf = (type) => type === "application/pdf";

  return (
    <>
      <div className="row g-4">
        {documents.length === 0 && (
          <div className="text-center text-muted py-4 w-100">
            No documents uploaded
          </div>
        )}

        {documents.map((doc, index) => (
          <div key={doc.id} className="col-sm-6 col-md-4 col-lg-3">
            <Card className="shadow-sm h-100 pt-3" style={{ borderRadius: 16 }}>
              {/* Preview */}
              <div
                className="d-flex align-items-center justify-content-center"
                style={{ height: 150, cursor: isImage(doc.type) ? "pointer" : "default" }}
                onClick={() => isImage(doc.type) && setPreviewImage(doc.url)}
              >
                {doc.images?.[0] && (
                  <img src={doc.images?.[0].url} alt={doc.images?.[0].name} style={{ maxWidth: "100%" }} />
                // ) : isPdf(doc.type) ? (
                //   <FaFilePdf size={48} color="#ef4444" />
                // ) : (
                //   <FaImage size={48} color="#6b7280" />
                )}
              </div>

              <Card.Body className="d-flex flex-column">
                <div className="fw-semibold text-truncate mb-3">
                  {doc.name}
                </div>

                <div className="mt-auto d-flex gap-2">
                    <Button
                      size="sm"
                      variant="outline-primary"
                      className="flex-fill"
                      onClick={() => setPreviewImage(doc.url)}
                    >
                      <FaEye />
                    </Button>

                    <Button
                      size="sm"
                      variant="danger"
                      className="flex-fill"
                      href={doc.url}
                      download
                    >
                      <FaDownload />
                    </Button>
                </div>

                {canDelete ? (
                  <Button
                    size="sm"
                    variant="outline-danger"
                    className="mt-2"
                    onClick={() => onDelete(doc.id)}
                  >
                    <FaTrash /> Delete
                  </Button>
                ): null}
              </Card.Body>
            </Card>
          </div>
        ))}
      </div>

      <Modal show={!!previewImage} onHide={() => setPreviewImage(null)} centered size="lg">
        <Modal.Body className="p-0">
          <img src={previewImage} alt="Preview" style={{ width: "100%" }} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DocumentTab
